import React from 'react';

import InputLabel from '../InputLabel';
import { LinkButton } from '../LinkButton';
import { WidgetBox } from '../WidgetBox';
import {
  Card,
  CardBody,
  CardFooter,
  Disclaimer,
  Main,
  Output,
  OutputIcon,
  OutputValue,
  Wrapper,
} from './wrapper';

export interface CalculationBoxProps {
  children: React.ReactNode;
  label?: string;
  output: React.ReactNode;
  outputIcon?: React.ReactNode;
  outputFor?: string;
  disclaimer?: string;
  action?: {
    text: string;
    title: string;
    onClick: () => void;
  };
}

const CalculationBox = ({
  children,
  label,
  output,
  outputIcon,
  outputFor,
  disclaimer,
  action,
}: CalculationBoxProps) => (
  <WidgetBox $tone="accentTertiary">
    <Wrapper>
      <Main>{children}</Main>
      <Card>
        <CardBody>
          {label && <InputLabel asDiv>{label}</InputLabel>}
          <Output $hasDisclaimer={!!disclaimer}>
            {outputIcon && <OutputIcon>{outputIcon}</OutputIcon>}
            <OutputValue htmlFor={outputFor}>{output}</OutputValue>
          </Output>
          {disclaimer && <Disclaimer>{disclaimer}</Disclaimer>}
        </CardBody>
        {action && (
          <CardFooter>
            <LinkButton onClick={action.onClick} title={action.title}>
              {action.text}
            </LinkButton>
          </CardFooter>
        )}
      </Card>
    </Wrapper>
  </WidgetBox>
);

export default CalculationBox;
